// Contenu des pages SEO « Homme à tout faire » (page mère + pages régionales).
// Rédigé par BOLÉAN, 2026-10-02. Les réponses de FAQ alimentent aussi le JSON-LD FAQPage :
// garder le texte visible et le schéma identiques en modifiant ici seulement.

export const HANDYMAN_HUB = {
  "title": "Homme à tout faire au Québec | DIGO, Humains à tout faire",
  "description": "Besoin d'un homme à tout faire? Sur DIGO, des travailleurs autonomes montent vos meubles, déneigent, rangent et plus. Publiez votre demande gratuitement.",
  "h1": "Homme à tout faire? Chez DIGO, on dit humains à tout faire.",
  "intro": [
    "Vous cherchez un homme à tout faire pour monter un meuble, déneiger l'entrée ou ranger le cabanon avant l'hiver? Vous êtes au bon endroit. DIGO est la plateforme québécoise qui met en contact les gens qui manquent de temps avec des travailleurs autonomes de leur région, prêts à donner un coup de main."
  ],
  "whyTitle": "Pourquoi « humain » plutôt qu'« homme »?",
  "why": [
    "Parce que le coup de main dont vous avez besoin n'a pas de genre. Sur DIGO, la personne qui monte votre bibliothèque peut être un étudiant, une retraitée habile de ses mains ou un parent qui complète ses revenus. Ce qui compte : qu'elle soit disponible, fiable et bien notée par ceux qu'elle a aidés.",
    "L'homme à tout faire d'hier fait place aux humains à tout faire d'aujourd'hui. Le service est le même, l'équipe est plus grande."
  ],
  "servicesTitle": "Ce que nos humains à tout faire peuvent faire pour vous",
  "services": [
    "Montage de meubles",
    "Déneigement",
    "Entretien de terrain",
    "Rangement saisonnier",
    "Lavage de vitres",
    "Ménage ponctuel",
    "Commissions",
    "Attente de livraison",
    "Promenade de chien",
    "Accompagnement d'aînés",
    "Répit"
  ],
  "servicesNote": "Une tâche qui n'est pas dans la liste? Décrivez-la dans votre demande, photos à l'appui.",
  "excludedTitle": "Ce que DIGO ne fait pas",
  "excluded": "Les travaux de construction et de rénovation qui exigent une licence de la RBQ ou des cartes de la CCQ (électricité, plomberie, structure, toiture) ne se font pas sur DIGO. Pour ces travaux, faites appel à un entrepreneur licencié.",
  "workerTitle": "Vous êtes une personne à tout faire?",
  "worker": "Vous êtes habile, disponible et vous aimez rendre service? Inscrivez-vous comme travailleur autonome sur DIGO. Vous choisissez vos catégories, vos régions et vos prix. Vous recevez une notification dès qu'une demande correspond à ce que vous offrez. L'inscription est gratuite.",
  "regionsTitle": "Partout au Québec",
  "regionsIntro": "DIGO met en contact clients et travailleurs autonomes partout au Québec. Trouvez des humains à tout faire près de chez vous :",
  "faq": [
    {
      "question": "Combien coûte un homme à tout faire sur DIGO?",
      "answer": "Le prix dépend de la tâche. Chaque travailleur fixe son prix et vous choisissez l'offre qui vous convient. Publier une demande est gratuit."
    },
    {
      "question": "Est-ce que je trouve seulement des hommes à tout faire?",
      "answer": "Non. Les travailleurs DIGO sont des femmes et des hommes de tous les âges. C'est pour ça qu'on parle d'humains à tout faire."
    },
    {
      "question": "Les travailleurs sont-ils des employés de DIGO?",
      "answer": "Non. Ce sont des travailleurs autonomes qui offrent leurs services par la plateforme."
    },
    {
      "question": "Quand le travailleur est-il payé?",
      "answer": "DIGO retient votre paiement et le verse au travailleur après votre confirmation que le service a été rendu."
    },
    {
      "question": "Puis-je réserver un service toutes les semaines?",
      "answer": "Oui. Indiquez une fréquence dans votre demande (jours, heure, date de fin). Chaque visite se paie séparément."
    },
    {
      "question": "DIGO fait-il des rénovations?",
      "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus."
    }
  ]
};

export const HANDYMAN_STEPS = [
  {
    "title": "Publiez votre demande",
    "text": "Décrivez la tâche, ajoutez des photos, choisissez le moment idéal ou une fréquence régulière. C'est gratuit."
  },
  {
    "title": "Recevez des offres",
    "text": "Les travailleurs de votre secteur vous proposent leur prix. Consultez leurs profils, leurs avis et leur note avant de choisir."
  },
  {
    "title": "Payez par la plateforme",
    "text": "Votre paiement est retenu par DIGO et versé au travailleur quand vous confirmez que le service a été rendu. Votre adresse exacte reste privée jusqu'au paiement."
  },
  {
    "title": "Évaluez",
    "text": "Votre note aide toute la communauté à choisir."
  }
];

export const HANDYMAN_REGIONS = [
  {
    "slug": "montreal",
    "name": "Montréal",
    "linkLabel": "Homme à tout faire à Montréal",
    "title": "Homme à tout faire à Montréal | DIGO",
    "h1": "Homme à tout faire à Montréal",
    "areaType": "City",
    "areaName": "Montréal",
    "description": "Homme à tout faire à Montréal : montage de meubles, déneigement d'escaliers, ménage de fin de bail. Publiez votre demande gratuitement sur DIGO.",
    "intro": "En ville, le temps file plus vite que les tâches. Un meuble en boîte depuis trois semaines, un escalier extérieur à déglacer avant le travail, un colis à attendre entre deux réunions : sur DIGO, vous publiez la tâche et les humains à tout faire de votre quartier vous proposent leur aide. Hommes ou femmes, étudiants ou retraités, ce sont des personnes disponibles, près de chez vous.",
    "servicesTitle": "Ce qu'on nous demande le plus à Montréal",
    "services": [
      {
        "label": "Montage de meubles",
        "text": "lit, commode, bibliothèque, bureau de télétravail. La période du 1er juillet en est le sommet."
      },
      {
        "label": "Déneigement",
        "text": "escaliers extérieurs, balcons et petites entrées que la charrue ne touche pas."
      },
      {
        "label": "Ménage ponctuel",
        "text": "fin de bail, avant une visite, après une rénovation."
      },
      {
        "label": "Attente de livraison",
        "text": "quelqu'un à la maison pendant que vous êtes au bureau."
      },
      {
        "label": "Rangement saisonnier",
        "text": "mobilier de balcon, vélos, casier de rangement."
      },
      {
        "label": "Promenade de chien et accompagnement d'aînés",
        "text": "des coups de main réguliers, à la semaine."
      }
    ],
    "localTitle": "La réalité montréalaise",
    "local": "Logements en hauteur, escaliers en colimaçon, stationnement compté : à Montréal, une petite tâche demande souvent plus d'organisation que de temps. Un travailleur du quartier arrive à pied, en vélo ou en métro et connaît ces contraintes. Pour une tâche qui revient (promenade du chien, déneigement après chaque tempête), fixez une fréquence dans votre demande.",
    "sectorsTitle": "Quartiers desservis",
    "sectors": "Plateau-Mont-Royal, Rosemont, Villeray, Hochelaga-Maisonneuve, Ahuntsic-Cartierville, Côte-des-Neiges, Notre-Dame-de-Grâce, Verdun, Le Sud-Ouest, Saint-Laurent, Anjou, Montréal-Nord, l'Ouest-de-l'Île et tous les autres arrondissements de l'île.",
    "workerTitle": "Vous êtes habile et vous habitez Montréal?",
    "worker": "Vos voisins ont des tâches à confier. Inscrivez-vous comme travailleur autonome, choisissez vos catégories et vos prix, et recevez une notification dès qu'une demande vous correspond. Idéal pour compléter un horaire d'études ou de travail à temps partiel.",
    "faqTitle": "Questions fréquentes à Montréal",
    "faq": [
      {
        "question": "Trouve-t-on de l'aide pour le 1er juillet?",
        "answer": "Oui, publiez votre demande de montage de meubles ou de ménage de fin de bail le plus tôt possible : c'est la période la plus demandée de l'année."
      },
      {
        "question": "Un travailleur peut-il déneiger mon escalier après chaque tempête?",
        "answer": "Oui. Indiquez une fréquence dans votre demande. Chaque passage se paie séparément, par la plateforme."
      },
      {
        "question": "DIGO fait-il des rénovations de plex ou de condo?",
        "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus. Pour ces travaux, faites appel à un entrepreneur licencié."
      }
    ]
  },
  {
    "slug": "laval",
    "name": "Laval",
    "linkLabel": "Homme à tout faire à Laval",
    "title": "Homme à tout faire à Laval | DIGO",
    "h1": "Homme à tout faire à Laval",
    "areaType": "City",
    "areaName": "Laval",
    "description": "Homme à tout faire à Laval : entretien de terrain, déneigement, rangement du garage et montage de meubles. Publiez votre demande gratuitement sur DIGO.",
    "intro": "À Laval, la maison vient avec un terrain, une entrée, un garage, et la liste de tâches qui va avec. Tonte, feuilles, déneigement, boîtes au sous-sol : sur DIGO, vous décrivez ce qu'il y a à faire et les humains à tout faire lavallois vous font des offres. Vous comparez, vous choisissez, c'est réglé.",
    "servicesTitle": "Ce qu'on nous demande le plus à Laval",
    "services": [
      {
        "label": "Entretien de terrain",
        "text": "tonte, ramassage des feuilles, désherbage, nettoyage du printemps."
      },
      {
        "label": "Déneigement",
        "text": "entrée, trottoir de façade, devant du garage, galerie."
      },
      {
        "label": "Rangement saisonnier",
        "text": "remiser le mobilier de patio, sortir les pneus, réorganiser le garage ou le cabanon."
      },
      {
        "label": "Montage de meubles",
        "text": "chambre d'enfant, mobilier de sous-sol, équipement d'entraînement."
      },
      {
        "label": "Lavage de vitres",
        "text": "au printemps et à l'automne."
      },
      {
        "label": "Répit et accompagnement d'aînés",
        "text": "un soutien régulier pour un parent qui vit encore chez lui."
      }
    ],
    "localTitle": "Les tâches lavalloises suivent les saisons",
    "local": "Avril : nettoyage du terrain et des vitres. Été : tonte aux semaines. Octobre : feuilles et remisage. Hiver : déneigement après chaque bordée. Si la tâche revient, créez une demande récurrente : le même travailleur peut revenir à chaque visite, au prix convenu.",
    "sectorsTitle": "Secteurs desservis",
    "sectors": "Chomedey, Sainte-Rose, Fabreville, Vimont, Auteuil, Duvernay, Laval-des-Rapides, Pont-Viau, Sainte-Dorothée, Laval-Ouest, Saint-François et l'ensemble de l'île Jésus.",
    "workerTitle": "Travailler près de chez vous, à Laval",
    "worker": "Vous avez une tondeuse, une pelle et quelques heures libres? Inscrivez-vous comme travailleur autonome sur DIGO, choisissez vos secteurs de Laval et vos prix, et recevez une notification quand une demande correspond à vos services.",
    "faqTitle": "Questions fréquentes à Laval",
    "faq": [
      {
        "question": "Puis-je avoir le même travailleur pour la tonte tout l'été?",
        "answer": "Oui. Créez une demande récurrente (jours, heure, date de fin). Le travailleur propose chaque visite au prix convenu et vous la payez par la plateforme."
      },
      {
        "question": "Est-ce que DIGO offre des contrats de déneigement saisonniers?",
        "answer": "DIGO met en contact avec des travailleurs autonomes qui déneigent à la visite ou de façon récurrente. Le prix est fixé par le travailleur, visite par visite."
      },
      {
        "question": "DIGO peut-il refaire mon sous-sol?",
        "answer": "Non. Les travaux de construction ou de rénovation qui exigent une licence RBQ ou des cartes CCQ sont exclus."
      }
    ]
  },
  {
    "slug": "rive-nord",
    "name": "Rive-Nord",
    "linkLabel": "Homme à tout faire sur la Rive-Nord",
    "title": "Homme à tout faire sur la Rive-Nord | DIGO",
    "h1": "Homme à tout faire sur la Rive-Nord",
    "areaType": "AdministrativeArea",
    "areaName": "Rive-Nord de Montréal",
    "description": "Homme à tout faire sur la Rive-Nord : Terrebonne, Blainville, Saint-Eustache, Repentigny et plus. Confiez vos tâches à un travailleur de chez vous.",
    "intro": "Entre l'autoroute matin et soir, les activités des enfants et la maison à entretenir, les fins de semaine raccourcissent vite sur la Rive-Nord. DIGO vous redonne du temps : publiez votre tâche, les humains à tout faire de votre ville vous proposent leur aide, et vous gardez votre samedi.",
    "servicesTitle": "Ce qu'on nous demande le plus sur la Rive-Nord",
    "services": [
      {
        "label": "Entretien de terrain",
        "text": "tonte, taille légère, feuilles, nettoyage de plates-bandes."
      },
      {
        "label": "Déneigement",
        "text": "entrée double, abords du garage, escaliers de façade."
      },
      {
        "label": "Montage de meubles",
        "text": "balançoire, trampoline, mobilier de patio, meubles de chambre."
      },
      {
        "label": "Commissions",
        "text": "épicerie, pharmacie, retour d'un colis pendant que vous êtes au travail en ville."
      },
      {
        "label": "Ménage ponctuel",
        "text": "grand ménage du printemps, avant de recevoir."
      },
      {
        "label": "Rangement saisonnier",
        "text": "piscine fermée, mobilier rentré, garage réorganisé."
      }
    ],
    "localTitle": "Pensé pour les familles qui font la navette",
    "local": "Si vous travaillez à Montréal ou à Laval, les tâches de semaine attendent souvent le week-end. Avec une demande récurrente, un travailleur peut tondre le mercredi ou déneiger tôt le matin, pendant que vous êtes sur la route. Vous suivez tout dans l'app et vous payez par la plateforme.",
    "sectorsTitle": "Villes desservies",
    "sectors": "Terrebonne, Mascouche, Repentigny, Blainville, Boisbriand, Sainte-Thérèse, Rosemère, Lorraine, Bois-des-Filion, Saint-Eustache, Deux-Montagnes, Pointe-Calumet, Charlemagne, L'Assomption. (Laval et Mirabel ont leur propre page.)",
    "workerTitle": "Rendre service sur la Rive-Nord",
    "worker": "Vous connaissez votre coin et vous aimez travailler de vos mains? Inscrivez-vous comme travailleur autonome sur DIGO. Vous choisissez les villes où vous vous déplacez, vos catégories et vos prix.",
    "faqTitle": "Questions fréquentes sur la Rive-Nord",
    "faq": [
      {
        "question": "Le travailleur doit-il venir de ma ville?",
        "answer": "Non. Chaque travailleur choisit les régions où il se déplace; ceux qui couvrent votre secteur peuvent vous faire une offre."
      },
      {
        "question": "Puis-je faire monter un module de jeu ou un trampoline?",
        "answer": "Oui, c'est du montage. Ajoutez des photos et le modèle dans votre demande pour recevoir des offres plus justes."
      },
      {
        "question": "DIGO construit-il des patios ou des clôtures?",
        "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus."
      }
    ]
  },
  {
    "slug": "rive-sud",
    "name": "Rive-Sud",
    "linkLabel": "Homme à tout faire sur la Rive-Sud",
    "title": "Homme à tout faire sur la Rive-Sud | DIGO",
    "h1": "Homme à tout faire sur la Rive-Sud",
    "areaType": "AdministrativeArea",
    "areaName": "Rive-Sud de Montréal",
    "description": "Homme à tout faire sur la Rive-Sud : Longueuil, Brossard, Boucherville, Châteauguay et plus. Montage, déneigement, terrain. Demande gratuite sur DIGO.",
    "intro": "Un bungalow à Boucherville, un condo neuf à Brossard, une maison de ville à Longueuil : sur la Rive-Sud, chaque type de logement a sa liste de petites tâches. DIGO vous met en contact avec les humains à tout faire de votre secteur pour s'en occuper, sans avoir à traverser les ponts.",
    "servicesTitle": "Ce qu'on nous demande le plus sur la Rive-Sud",
    "services": [
      {
        "label": "Montage de meubles",
        "text": "surtout dans les nouveaux condos et les maisons récemment achetées."
      },
      {
        "label": "Entretien de terrain",
        "text": "tonte, feuilles, nettoyage de cour."
      },
      {
        "label": "Déneigement",
        "text": "entrée, balcon, accès au cabanon."
      },
      {
        "label": "Attente de livraison",
        "text": "réception d'un électroménager ou d'un meuble pendant votre journée de travail."
      },
      {
        "label": "Lavage de vitres",
        "text": "fenêtres de plain-pied, portes-patio."
      },
      {
        "label": "Accompagnement d'aînés",
        "text": "rendez-vous, courses, compagnie."
      }
    ],
    "localTitle": "Un coup de main local, sans traverser les ponts",
    "local": "Pont Jacques-Cartier, Champlain, tunnel : quand le dépannage vient de l'autre rive, l'horaire devient vite compliqué. Sur DIGO, les travailleurs choisissent les villes où ils se déplacent. Précisez votre secteur dans la demande et ceux qui y travaillent vous feront une offre.",
    "sectorsTitle": "Villes desservies",
    "sectors": "Longueuil (Vieux-Longueuil, Saint-Hubert, Greenfield Park), Brossard, Boucherville, Saint-Lambert, Saint-Bruno-de-Montarville, Sainte-Julie, Varennes, La Prairie, Candiac, Delson, Châteauguay, Saint-Constant, Sainte-Catherine.",
    "workerTitle": "Travailler sur la Rive-Sud avec DIGO",
    "worker": "Retraité actif, étudiant au cégep, parent qui veut des heures flexibles? Inscrivez-vous comme travailleur autonome. Vous réglez vos villes, vos catégories et vos prix, et vous acceptez seulement les demandes qui vous conviennent.",
    "faqTitle": "Questions fréquentes sur la Rive-Sud",
    "faq": [
      {
        "question": "Quelqu'un peut-il attendre ma livraison pendant que je suis à Montréal?",
        "answer": "Oui. Publiez une demande d'attente de livraison avec la plage horaire. Votre adresse exacte n'est transmise au travailleur qu'après le paiement."
      },
      {
        "question": "Combien coûte le montage d'un meuble?",
        "answer": "Chaque travailleur fixe son prix. Ajoutez le nom du meuble ou une photo de la boîte pour recevoir des offres comparables."
      },
      {
        "question": "DIGO installe-t-il des luminaires ou des robinets?",
        "answer": "Non. L'électricité et la plomberie exigent une licence RBQ et des cartes CCQ : ces travaux sont exclus."
      }
    ]
  },
  {
    "slug": "mirabel",
    "name": "Mirabel",
    "linkLabel": "Homme à tout faire à Mirabel",
    "title": "Homme à tout faire à Mirabel | DIGO",
    "h1": "Homme à tout faire à Mirabel",
    "areaType": "City",
    "areaName": "Mirabel",
    "description": "Homme à tout faire à Mirabel : grands terrains, déneigement de longues entrées, montage de meubles. Publiez votre demande gratuitement sur DIGO.",
    "intro": "Entre les nouveaux quartiers de Saint-Janvier et de Saint-Canut et les grands terrains de Sainte-Scholastique ou de Saint-Hermas, les tâches ne manquent pas à Mirabel. Publiez la vôtre et les humains à tout faire de votre secteur vous proposent leur aide.",
    "servicesTitle": "Ce qu'on nous demande le plus à Mirabel",
    "services": [
      {
        "label": "Entretien de terrain",
        "text": "grands terrains à tondre, feuilles à ramasser, bordures à dégager."
      },
      {
        "label": "Déneigement",
        "text": "longues entrées, accès au garage détaché ou à la remise."
      },
      {
        "label": "Montage de meubles",
        "text": "maisons neuves à meubler dans les nouveaux développements."
      },
      {
        "label": "Rangement saisonnier",
        "text": "garage, remise, équipement de piscine et de jardin."
      },
      {
        "label": "Promenade de chien et répit",
        "text": "coups de main réguliers pour les familles occupées."
      },
      {
        "label": "Commissions",
        "text": "quand le prochain magasin est à quinze minutes de route."
      }
    ],
    "localTitle": "Une ville grande comme une région",
    "local": "Mirabel couvre un territoire immense, avec des secteurs urbains et des rangs agricoles. Indiquez bien votre secteur dans la demande : les travailleurs voient le secteur approximatif avant de faire une offre, et votre adresse exacte reste privée jusqu'au paiement.",
    "sectorsTitle": "Secteurs desservis",
    "sectors": "Saint-Janvier, Saint-Canut, Domaine-Vert Nord, Domaine-Vert Sud, Sainte-Monique, Saint-Augustin, Saint-Benoît, Sainte-Scholastique, Saint-Hermas, Petit-Saint-Charles.",
    "workerTitle": "Vous habitez Mirabel et vous avez du temps?",
    "worker": "Inscrivez-vous comme travailleur autonome sur DIGO et aidez vos voisins de secteur. Vous choisissez vos catégories, vos prix et les secteurs où vous vous déplacez.",
    "faqTitle": "Questions fréquentes à Mirabel",
    "faq": [
      {
        "question": "Mon terrain est grand : comment obtenir un prix juste?",
        "answer": "Donnez la superficie approximative et ajoutez des photos. Les travailleurs ajustent leur offre en conséquence."
      },
      {
        "question": "Quelqu'un peut-il faire mes commissions si j'habite un rang?",
        "answer": "Oui. Publiez une demande de commissions avec la liste et l'endroit. Votre adresse exacte n'est transmise au travailleur qu'après le paiement."
      },
      {
        "question": "DIGO fait-il des travaux de toiture ou de structure?",
        "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus."
      }
    ]
  },
  {
    "slug": "laurentides",
    "name": "Laurentides",
    "linkLabel": "Homme à tout faire dans les Laurentides",
    "title": "Homme à tout faire dans les Laurentides | DIGO",
    "h1": "Homme à tout faire dans les Laurentides",
    "areaType": "AdministrativeArea",
    "areaName": "Laurentides",
    "description": "Homme à tout faire dans les Laurentides : ouverture et fermeture de chalet, déneigement, terrain. Saint-Jérôme, Saint-Sauveur, Tremblant et plus.",
    "intro": "Maison à l'année à Saint-Jérôme ou chalet au bord d'un lac à Val-David : dans les Laurentides, les tâches suivent le rythme des saisons et des fins de semaine. Sur DIGO, vous confiez ce qui doit être fait aux humains à tout faire de la région, même quand vous êtes en ville.",
    "servicesTitle": "Ce qu'on nous demande le plus dans les Laurentides",
    "services": [
      {
        "label": "Ouverture et fermeture de chalet",
        "text": "ménage, rangement du mobilier extérieur, quai et embarcations à remiser."
      },
      {
        "label": "Déneigement",
        "text": "entrée de chalet avant votre arrivée du vendredi, galerie, accès à la porte."
      },
      {
        "label": "Entretien de terrain",
        "text": "feuilles, branches tombées, nettoyage du printemps."
      },
      {
        "label": "Ménage ponctuel",
        "text": "entre deux séjours ou avant l'arrivée de la famille."
      },
      {
        "label": "Attente de livraison",
        "text": "recevoir un meuble ou un électroménager au chalet en votre absence."
      },
      {
        "label": "Accompagnement d'aînés",
        "text": "pour les parents qui ont choisi de vieillir dans la région."
      }
    ],
    "localTitle": "Pour les propriétaires qui sont souvent ailleurs",
    "local": "Beaucoup de propriétaires des Laurentides vivent à Montréal une partie de l'année. Avec DIGO, vous publiez votre demande à distance, vous suivez la conversation dans l'app et vous confirmez que le service a été rendu avant que le travailleur soit payé.",
    "sectorsTitle": "Secteurs desservis",
    "sectors": "Saint-Jérôme, Prévost, Piedmont, Saint-Sauveur, Sainte-Adèle, Morin-Heights, Val-David, Val-Morin, Sainte-Agathe-des-Monts, Mont-Tremblant, Saint-Hippolyte, Sainte-Sophie. (Mirabel et la couronne nord ont leur propre page.)",
    "workerTitle": "Travailler dans les Laurentides avec DIGO",
    "worker": "Vous habitez la région à l'année? Les propriétaires de chalets cherchent des gens fiables près de chez eux. Inscrivez-vous comme travailleur autonome, choisissez vos secteurs et vos prix.",
    "faqTitle": "Questions fréquentes dans les Laurentides",
    "faq": [
      {
        "question": "Puis-je faire déneiger mon chalet avant chaque fin de semaine?",
        "answer": "Oui. Créez une demande récurrente, par exemple chaque vendredi. Chaque passage se paie séparément, par la plateforme."
      },
      {
        "question": "Dois-je être sur place pendant le service?",
        "answer": "Pas nécessairement. Entendez-vous avec le travailleur dans la conversation de la demande sur l'accès et les consignes."
      },
      {
        "question": "DIGO répare-t-il les toitures ou les quais?",
        "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus."
      }
    ]
  },
  {
    "slug": "quebec",
    "name": "Québec",
    "linkLabel": "Homme à tout faire à Québec",
    "title": "Homme à tout faire à Québec | DIGO",
    "h1": "Homme à tout faire à Québec",
    "areaType": "City",
    "areaName": "Québec",
    "description": "Homme à tout faire à Québec : déneigement, montage de meubles, ménage. Sainte-Foy, Charlesbourg, Beauport, Limoilou et Lévis. Demande gratuite sur DIGO.",
    "intro": "À Québec, l'hiver arrive tôt, la neige tombe fort et les escaliers de Limoilou ne se déneigent pas tout seuls. DIGO arrive dans la capitale avec une idée simple : vous publiez votre tâche, les humains à tout faire de votre quartier vous font des offres, vous payez par la plateforme quand c'est fait.",
    "servicesTitle": "Ce qu'on nous demande le plus à Québec",
    "services": [
      {
        "label": "Déneigement",
        "text": "escaliers, balcons, entrées et abords du stationnement, après chaque bordée."
      },
      {
        "label": "Montage de meubles",
        "text": "appartements étudiants, premiers condos, mobilier de bureau à domicile."
      },
      {
        "label": "Ménage ponctuel",
        "text": "fin de bail, départ d'un locataire, grand ménage du printemps."
      },
      {
        "label": "Rangement saisonnier",
        "text": "abri d'auto, pneus, mobilier de balcon."
      },
      {
        "label": "Entretien de terrain",
        "text": "surtout dans les secteurs de Charlesbourg, Beauport et Lévis."
      },
      {
        "label": "Accompagnement d'aînés et répit",
        "text": "visites, rendez-vous, courses."
      }
    ],
    "localTitle": "L'hiver de Québec, une tâche à part entière",
    "local": "La neige à Québec est plus abondante qu'à Montréal, et elle revient souvent. Plutôt que de chercher quelqu'un à chaque tempête, créez une demande récurrente : le travailleur propose chaque passage au prix convenu et vous payez visite par visite.",
    "sectorsTitle": "Secteurs desservis",
    "sectors": "La Cité-Limoilou, Saint-Roch, Saint-Sauveur, Sainte-Foy, Sillery, Cap-Rouge, Charlesbourg, Beauport, Les Rivières, Val-Bélair, L'Ancienne-Lorette, Saint-Augustin-de-Desmaures et Lévis.",
    "workerTitle": "Devenez l'un des premiers travailleurs DIGO à Québec",
    "worker": "DIGO s'installe dans la région de la capitale et cherche des personnes fiables pour répondre aux premières demandes. Inscrivez-vous comme travailleur autonome, choisissez vos secteurs, vos catégories et vos prix.",
    "faqTitle": "Questions fréquentes à Québec",
    "faq": [
      {
        "question": "DIGO est-il offert à Québec ou seulement à Montréal?",
        "answer": "DIGO est offert partout au Québec, y compris dans la capitale. Publiez votre demande : les travailleurs qui couvrent votre secteur peuvent vous faire une offre."
      },
      {
        "question": "Je suis étudiant à l'Université Laval : puis-je travailler sur DIGO?",
        "answer": "Oui. Inscrivez-vous comme travailleur autonome : vous choisissez vos heures, vos tâches et vos prix."
      },
      {
        "question": "DIGO rénove-t-il les logements?",
        "answer": "Non. Les travaux qui exigent une licence RBQ ou des cartes CCQ sont exclus."
      }
    ]
  }
];

export const findHandymanRegion = slug => HANDYMAN_REGIONS.find(r => r.slug === slug) || null;
